module.exports = __webpack_public_path__ + "img/攻防演练.9336cacb.png";